import React from 'react';
import { AthleteEffortDetailProps } from './effort.types';

type DetailComponent = React.ComponentType<AthleteEffortDetailProps>;

export const AthleteEffortDetailLazy = React.lazy(
  (): Promise<{ default: DetailComponent }> =>
    import('./AthleteEffortDetail').then((m) => ({
      default: m.AthleteEffortDetail as DetailComponent,
    })),
);

export default AthleteEffortDetailLazy;
